import { forwardRef, memo } from 'react'

import { IconCurrentLocation } from '~/components'

type Props = {
  className?: string
  onClick: () => void
}

const UserLocationButtonComponent = forwardRef<HTMLButtonElement, Props>(
  ({ className, onClick }, ref) => {
    return (
      <button className={className} onClick={onClick} ref={ref}>
        <IconCurrentLocation className="mx-auto" />
      </button>
    )
  },
)
UserLocationButtonComponent.displayName = 'UserLocationButtonComponent'

export const UserLocationButton = memo(UserLocationButtonComponent)
UserLocationButton.displayName = 'UserLocationButton'
